import { Alert } from '@/components';
import { AlertProps } from '@/interfaces';
import { FC } from 'react';
const ErrorAlert: FC<AlertProps> = ({
  title = 'Error',
  icon = 'error',
  description = 'This is just an error message, but we are so glad you are here!',
  ...props
}) => {
  return (
    <Alert
      intent="error"
      title={title}
      icon={icon}
      description={description}
      {...props}
    />
  );
};
export default ErrorAlert;
